<template>
	<div class="content-demo-cart">		
		<transition name="checkout-anim"  enter-active-class="animate__animated animate__backInUp" leave-active-class="animate__animated animate__backOutDown">
				<checkout
				v-if="statusCheckout" 		
				@closeCheckout= "statusCheckout = $event">		
				</checkout>
			</transition>
		<div class="main-cart" v-show="!statusCheckout">
			<div class="empty-cart" v-if="List_cart.length == 0">
				<i class="fas fa-shopping-cart"></i>
				<h4>Tu carrito está vacio</h4>
			</div>
			<div class="first-section">
				<div class="first-section-intern">
					<div class="header">
						<h4>Tu carrito</h4>
						<i class="fas fa-times" @click="close()"></i>
					</div>					
				</div>
			</div>
			<div class="second-section">
				<div class="second-section-intern">
					<div class="single-cart-product" v-for="item in List_cart">
						<div class="image-container">
							<img :src="item.image" alt="">
						</div>
						<div class="information-container">
							<div class="delete-product">
								<!--<h4 class="product-category">Category</h4>-->
								<i class="fas fa-times" @click="Deleteproduct(item)"></i>
							</div>
							<h4 class="product-name">{{ item.name }}</h4>
							<h4 class="product-combination" v-if="item.combination">{{ item.combination }}</h4>
							<!--<h4 class="product-quantity">Cantidad: {{item.quantity}}</h4>-->
							<div class="product-quantity">
								<i class="fas fa-minus" @click="restQuantity(item)"></i>
								<label>{{ item.quantity }}</label>
								<i class="fas fa-plus" @click="updateQuantity(item)"></i>
							</div>
							<h4 class="product-price">${{ Intl.NumberFormat("de-DE").format(item.value_sale * item.quantity) }}</h4>
						</div>
					</div>
				</div>
			</div>
			<div class="third-section">
				<div class="cart-total">
					<h4 class="text-total">Total:</h4>
					<h4 class="value-total">${{ Intl.NumberFormat("de-DE").format(total) }}</h4>
				</div>
				<div class="shop-button">
					<button @click="openCheckout();" v-bind:style="{ backgroundColor : color_licencia }" id="btn-checkout"><i class="fas fa-shopping-cart" ></i>Ir al checkout</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style type="text/css" scoped>

	.product-quantity{
		align-self: center;
		width: 35%;
		padding: 6px 3px 6px 3px;
		display: flex;
		justify-content: space-around;
		border: 2px solid #ddd;
		align-items: center;
		border-radius: 7px;
		margin-top: 7px;
		margin-bottom: 7px;
	}

	.product-quantity label{
		margin-bottom: 0 !important;
	}

	.product-quantity i{
		cursor: pointer;
	}

	.first-section{
		width: 100%;
		height: auto;
		background: #fff;
	}

	.first-section-intern{
		width: 100%;
		height: 10vh;
		background: #F0F5F9;
		border-bottom-left-radius: 50px;
	}

	.header{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 35px 0px 35px;
	}

	.header h4{
		font-size: 25px;
		font-weight: 600;
		color: #12243C;
		margin-bottom: 0 !important;
	}

	.header i{
		font-size: 19px;
		color: #12243C;
	}

	.items_added{
		width: 100%;
		padding: 20px 15px 10px 15px;
	}

	.items_added h4{
		font-size: 16px;
		font-weight: 600;
		color: #B8B7B7;
		margin-bottom: 0 !important;
	}

	.second-section{
		width: 100%;
		height: auto;
		background: #F0F5F9;
	}

	.second-section-intern{
		width: 100%;
		background: #fff;
		height: 70vh;
		border-top-right-radius: 70px; 
		padding: 25px 25px 0px 25px;
		overflow-y: scroll;
		z-index: 2;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;
	}

	.single-cart-product{
		width: 100%;
		display: flex;
		justify-content: center;
		padding-top: 15px;
		padding-bottom: 15px;
		border-right: none;
		border-left: none;
		border-top: none;
		border-bottom: 1px solid #ECECEC;
	}

	.single-cart-product:last-of-type{
		border-bottom: 0;
	}

	.single-cart-product:first-of-type{
		border-bottom: 1px solid #ECECEC;
	}

	.image-container{
		width: 25%;
	}

	.image-container img{
		width: 80%;
		height: auto;
		border-radius: 15px;
	}

	.information-container{
		width: 60%;
		text-align: left;
		padding-top: 5px;
	}

	.delete-product{
		display: flex;
		justify-content: flex-end;
		padding-right: 13px;
	}

	.delete-product i{
		font-size: 16px;
		color: #B8B7B7;
	}

	.product-name{
		font-size: 21px;
		font-weight: 600;
		color: #12243C;
	}

	.product-combination{
		padding-top: 5px;
		font-size: 18px;
		font-weight: 500;
		color: #6B6B6B;
	}

	.product-category{
		font-size: 15px;
		font-weight: 500;
		color: #B8B7B7;
	}

	.product-quantity{
		font-size: 17px;
		font-weight: 500;
		color: #6B6B6B;
		padding-top: 4px;
		padding-bottom: 3px;
	}

	.product-price{
		padding-top: 5px;
		font-size: 23px;
		font-weight: 600;
		color: #48C174;
	}

	.information-container h4{
		margin-bottom: 0 !important;
	}

	.third-section{
		width: 100%;
		height: auto;
		background: #fff;
		padding: 25px 20px 15px 20px;
		margin-top: -30px;
	}

	.cart-total{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;
	}

	.cart-total h4{
		color: #12243C;
		margin-bottom: 0 !important;
	}

	.text-total{
		font-size: 23px;
	}

	.value-total{
		font-weight: 600;
		font-size: 25px;
	}

	.shop-button{
		width: 100%;
	}

	.shop-button button{
		padding: 10px 20px 10px 20px;
		border:none;
		background: #12243C;
		color: #fff;
		border-radius: 10px;
		font-weight: 600;
		font-size: 20px;
		width: 100%;
	}

	.shop-button button:focus{
		outline: none;
	}

	.shop-button i{
		font-size: 15px;
		margin-right: 9px;
		margin-bottom: 7px;
	}

	.empty-cart{
		
		position: absolute;
		top: 40%;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	.empty-cart i{
		font-size: 47px;
		color: #999999;
	}

	.empty-cart h4{
		margin-bottom: 0 !important;
		font-size: 26px;
		font-weight: 500;
		color: #999999;
	}



</style>

<script>
	import Vue from 'vue'
	import Vuesax from 'vuesax'
	import axios from 'axios';
	import { osName } from 'mobile-device-detect';
	import moment from 'moment'
	import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
	Vue.use(DatePickerPlugin);
	import 'vuesax/dist/vuesax.css' //Vuesax styles
	import Checkout from './Checkout';
  	Vue.use(Vuesax, {
    
	})
	let installEvent;
	export default {
	  props: ['cart'],	
	  components: {
	   	Checkout
	  },
	  data() {
	  	return {
	  		List_cart: JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`)) ? JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`)) : [],
	  		total: 0,
	  		color_licencia: localStorage.getItem('color_licencia'),
	  		statusCheckout: false,
	  		product_deleted: {}
	  	}
	  },
	  methods:{
	  	openCheckout(){
	  		localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(this.List_cart));	  		
	  		this.statusCheckout = true;
	  	},
	  	close(){
  			this.$emit('closeCartDetail',false);
  			this.$emit('productDeleted', this.product_deleted);
  		},
  		Deleteproduct(product){
  			this.product_deleted = product;
  			this.List_cart.forEach((item) => {
  				if (item.id == product.id) {
  					if (localStorage.getItem('order_discount')) {
	  					let total_discount = localStorage.getItem('order_discount');
	  					if (product.descuento > 0) {
	  						total_discount -= product.descuento;
	  						if (total_discount == 0) {
	  							localStorage.removeItem('id_coupon');
	  							localStorage.setItem('order_discount', total_discount);
	  							let position = this.List_cart.indexOf(product);
	  							this.List_cart.splice(position, 1);
	  							let lista_nueva = this.List_cart; 
	  							localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(lista_nueva));
	  						}
	  					}else{
	  						let position = this.List_cart.indexOf(product);
	  						this.List_cart.splice(position, 1);
	  						let lista_nueva = this.List_cart; 
	  						localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(lista_nueva));
	  					}
	  				}else{
	  					let position = this.List_cart.indexOf(product);
	  					this.List_cart.splice(position, 1);
	  					let lista_nueva = this.List_cart; 
	  					localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(lista_nueva));	
	  				}
  				}
  			})
  			this.updateTotal()
  			this.disabledButton()
  		},
  		updateQuantity(item){
  			console.log("algo")
  			item.quantity += 1;
  			this.total += parseInt(item.value_sale);
  		},
  		restQuantity(item){
  			if(item.quantity > 1){
				item.quantity -= 1;	
				this.total -= parseInt(item.value_sale);
			}
  		},
  		updateTotal(){
  			this.total = 0;
  			this.List_cart.forEach((product) => {
  				this.total += (parseInt(product.value_sale) * product.quantity);
  			});  			
  		},
  		disabledButton(){
	  		if (this.List_cart.length == 0) {
		  		document.getElementById("btn-checkout").disabled = true;
		  	}
  		}
	  },

	  mounted() {
	  	this.updateTotal()	  	
	  	this.disabledButton();
	  	console.log(this.List_cart)
	  }
	}
</script>